import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMemberCoverage } from '../../../../../global/ducks/mlps-api';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { setCoverageFormError, setMemberNewHireEnrollmentCoverage } from '../slice/new-hire-enrollment-slices';


export function useMemberCoverageState(memberGuid: string, formId: number) {
	const newHireCoverageState = useSelector<TcsmStates, any>(state => state.newHireEnrollmentState?.memberCoverageState);
	const dispatch = useDispatch();


	useEffect(() => {

		if (!newHireCoverageState && memberGuid && formId) {
			dispatch(getMemberCoverage(memberGuid, formId, (response) => {
				dispatch(setMemberNewHireEnrollmentCoverage(response?.data));
			}, () => dispatch(setCoverageFormError()),
			));
		}

	}, [memberGuid, formId]);

	return newHireCoverageState != null;
}